import { useCallback } from 'react';

import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

export function useGetShareTrackingData(): ShareActionsOptions['getTrackingData'] {
	return useCallback(
		(channel) => ({
			location: channel,
			view_context: 'news_show',
		}),
		[],
	);
}
